/*=========================================================================================
  File Name: store.js
  Description: Vuex store
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import Vue from 'vue'
import Vuex from 'vuex'

import state from './state'
import getters from './getters'
import mutations from './mutations'
import actions from './actions'

Vue.use(Vuex)

// import moduleTodo from './todo/moduleTodo.js'
import moduleCalendar from './calendar/moduleCalendar.js'
// import moduleChat from './chat/moduleChat.js'
// import moduleEmail from './email/moduleEmail.js'
// import moduleAuth from './auth/moduleAuth.js'
import moduleECommerce from './eCommerce/moduleECommerce.js'
import LeadsStorage from './leads/leads'
import LoginStorage from './Login/LoginStore'
import activityStorage from './activities/activitynote'
import clientStorage from './clients/clients'
import CommonStorage from './common/common'
import FileStorage from './file/file'
import notificationStorage from './notification/notification'
import homeworkStorage from './homeworkstore/homeworkStorage'
import message from './message/index'
import navMenuStorage from './navmenu/navMenuStore'
import attendanceStorage from './attendance/attendance'
import courseStorage from './course/course'

import graphStore from './graphStore/graphStore'
import schedulerStorage from './scheduler/scheduler'
import taskProjectStorage from './task-project/task-project'
import userStorage from './userManagement/userStore'
import AnalyticssStorage from './analytics/index'
import moduleCertificate from './certificate/moduleCertificate.js'

export default new Vuex.Store({
  getters,
  mutations,
  state,
  actions,
  modules: {
    // todo: moduleTodo,
    calendar: moduleCalendar,
    certificate: moduleCertificate,
    // chat: moduleChat,
    // email: moduleEmail,
    // auth: moduleAuth,
    eCommerce: moduleECommerce,
    LeadsStorage,
    LoginStorage,
    activityStorage,
    clientStorage,
    CommonStorage,
    FileStorage,
    notificationStorage,
    homeworkStorage,
    message,
    navMenuStorage,
    schedulerStorage,
    taskProjectStorage,
    userStorage,
    graphStore,
    attendanceStorage,
    courseStorage,
    AnalyticssStorage
  },
  strict: false
})
